import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { Workspace } from '@/hooks/api/models';

/**
 * 0480. ワークスペース招待再送
 * [PUT] /workspaces/:identifier/user_invitations/:id
 */
type Props = {
  identifier: string;
  id: number;
};
export const updateUserInvitation = (props: Props): Promise<Workspace> => {
  return axios.put(`/api/workspaces/${props.identifier}/user_invitations/${props.id}`);
};

export const useUpdateUserInvitation = () => {
  return useMutation({
    mutationFn: updateUserInvitation,
  });
};
